import React, { useState } from 'react';
import styled from 'styled-components';
import { flexCenter } from '../constants/styles';
import Title from './shared/Title';
import Text from './shared/Text';
import Button from './shared/Button';
import FinautaLogo from '../images/svgs/finauta/logo.svg';
import axios from 'axios';
import ClipLoader from 'react-spinners/ClipLoader';
import Icon from '../components/shared/Icon';
import { css } from '@emotion/core';
import { mp } from '../constants/utils';
import { useEffect } from 'react';
import { palette, breakpoints } from '../constants/styles';

const API_URL = 'https://us-central1-finauta-twilio.cloudfunctions.net/finauta_twilio/form';
// const API_URL =  'https://2d34f482d41a.ngrok.io/form';
const planes = [
  '$500 - Plan Básico',
  '$750 - Plan Estandar',
  '$1500 - Plan Completo',
  'Todavía no estoy seguro',
];

const StyledLoaderContainer = styled.div`
  position: fixed;
  background-color: white;
  opacity: 0.8;
  width: 100%;
  height: 100%;
`;

const StyledFormContainer = styled.div`
  ${flexCenter};
  background-color: white;
  width: 100vw;

  ${breakpoints.tablet} {
    max-width: 550px;
    height: 80%;
    margin-top: 50px;
    margin-bottom: 50px;
  }
`;

const StyledLabel = styled.label`
  width: 100%;
  margin-bottom: 20px;
  display: inline-block;
  font-weight: 400;
  font-size: 1.2em;
`;

const StyledInput = styled.input`
  margin-top: -2px;
  font-size: 1em;
  width: 100%;
  height: 32px;
  margin-top: 5px;
  margin-bottom: 5px;
  border: solid #cbd5e3;
  border-radius: 0;
  border-width: 0 0 2px 0;

  &::placeholder {
    color: #d4d4d4;
    opacity: 1; /* Firefox */
  }

  &:-ms-input-placeholder {
    /* Internet Explorer 10-11 */
    color: #d4d4d4;
  }

  &::-ms-input-placeholder {
    /* Microsoft Edge */
    color: #d4d4d4;
  }
`;

const StyledSelect = styled.select`
  width: 100%;
  height: 40px;
  padding: 10px;
  border: solid #cbd5e3;
  border-radius: 0;
  border-width: 0 0 2px 0;
`;

const StyledForm = styled.form`
  max-width: 400px;
  ${flexCenter};
  display: flex;
  flex: content;
  flex-flow: column;
  margin: 30px;
`;

const StyledIndicator = styled.p`
  color: red;
  display: inline;
`;

const Image = styled.img`
  margin: 24px;
`;

const SCHEDULES = {
  MORNING: '9:30 - 12:30',
  NOON: '13:00 - 16:00',
  AFTERNOON: '16:30 - 19:30',
};

const override = css`
  display: block;
  margin-left: auto;
  margin-right: auto;
  text-align: center;
  margin-top: 40%;
  border-width: 5px;
`;

const StyledFormBackground = styled.div`
  background-color: ${palette.sweetGray};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  ${breakpoints.tablet} {
    border-radius: 2px;
    box-shadow: 0 14px 28px rgba(0, 0, 0, 0.25), 0 10px 10px rgba(0, 0, 0, 0.22);
  }
`;

const AlignLeft = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  height: 100%;
`;

const HubspotForm = (props) => {
  const [scheduleOne, setScheduleOne] = useState(true);
  const [scheduleTwo, setScheduleTwo] = useState(true);
  const [scheduleThree, setScheduleThree] = useState(true);

  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [plan, setPlan] = useState('');

  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    mp('Form | Plan de pensión');
  }, []);

  const handleSubmit = (event) => {
    event.preventDefault();
    mp('Form | Plan de pensión | Envia datos');
    setIsLoading(true);
    console.log(`
        Name: ${name}
        Email: ${email}
        PhoneNumber: ${phoneNumber}
        Plan Selected: ${plan}
        Schedules avalavility: ${scheduleOne && SCHEDULES.MORNING}, ${scheduleTwo &&
      SCHEDULES.NOON}, ${scheduleThree && SCHEDULES.AFTERNOON}`);

    const availability = `N/A`;
    const plan_code = props.match.params.planLink ? props.match.params.planLink : '_';
    const referral = props.match.params.referralId ? props.match.params.referralId : '_';
    axios
      .post(
        API_URL,
        JSON.stringify({
          name: name,
          emailForm: email,
          phone: phoneNumber,
          plan_link: `https://app.finauta.com/retiro/res/73/${plan_code}`,
          tool: 'TwilioCloudFunction',
          source: 'Form',
          plan_selected: plan,
          availability,
          referral,
        }),
        {
          headers: {
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*',
          },
        },
      )
      .then((response) => {
        mp('Form | Plan de pensión | Success');
        window.location.replace(
          `https://app.finauta.com/felicidades/${phoneNumber}/${referral}/${plan_code}`,
        );
      })
      .catch((err) => {
        mp('Form | Plan de pensión | Error');
        window.location.replace('https://app.finauta.com/error');
        throw Error(err);
      });
  };

  return (
    <>
      <StyledFormBackground>
        {isLoading ? (
          <StyledLoaderContainer>
            <ClipLoader css={override} size={40} color={'#123abc'} />
          </StyledLoaderContainer>
        ) : (
          <></>
        )}
        <StyledFormContainer>
          <StyledForm id="form1" onSubmit={handleSubmit}>
            <Icon icon="finautaf" color={palette.secondaryColor} size={70} />
            <AlignLeft>
              <Title level={4} align="left">
                Estás a un paso de lograr tu pensión ideal
              </Title>
              <Text
                style={{ marginBottom: '20px' }}
                type="body"
                color={palette.darkerGray}
                align="left"
              >
                Para realizar un diagnóstico de tu caso, un miembro del equipo se comunicará
                contigo.
              </Text>
              <StyledLabel>
                Nombre:<StyledIndicator> *</StyledIndicator>
                <StyledInput
                  name="name"
                  placeholder="Juan Pérez"
                  type="text"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  required
                />
              </StyledLabel>

              <StyledLabel>
                Correo:<StyledIndicator> *</StyledIndicator>
                <StyledInput
                  name="email"
                  type="email"
                  value={email}
                  placeholder="tucorreo@ejemplo.com"
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </StyledLabel>

              <StyledLabel>
                Teléfono celular:<StyledIndicator> *</StyledIndicator>
                <Text type="body1" color="gray">
                  Sólo 10 dígitos
                </Text>
                <StyledInput
                  name="phoneNumber"
                  type="tel"
                  pattern="[1-9]{1}[0-9]{9}"
                  maxLength="10"
                  placeholder="8112581321"
                  value={phoneNumber}
                  onChange={(e) => setPhoneNumber(e.target.value)}
                  required
                />
              </StyledLabel>

              <StyledLabel>
                Plan de interés:<StyledIndicator> *</StyledIndicator>
                <Text style={{ marginBottom: '10px' }} type="body1" color="gray">
                  Elige una opción sin compromiso
                </Text>
                <StyledSelect
                  name="plan"
                  style={{
                    fontSize: '1.2rem',
                    lineHeight: '1.8',
                  }}
                  value={plan}
                  onChange={(e) => setPlan(e.target.value)}
                  required
                >
                  <option value="" selected hidden>
                    Selecciona una opción
                  </option>
                  {planes.map((plan, index) => (
                    <option key={plan}>{plan}</option>
                  ))}
                </StyledSelect>
              </StyledLabel>

              {/* <StyledLabel>
              ¿En qué horario te gustaría que te contactemos?
              <StyledIndicator>*</StyledIndica{' '}*or>
              <Text type="body1" color="gray">
                Elige las opciones de horario que más se ajusten a tus tiempos
              </Text>
              <input
                type="checkbox"
                checked={scheduleOne}
                onChange={() => setScheduleOne(!scheduleOne)}
              />
              <span class="checkmark">{SCHEDULES.MORNING}</span>
              <br />
              <input
                type="checkbox"
                checked={scheduleTwo}
                onChange={() => setScheduleTwo(!scheduleTwo)}
              />
              <span class="checkmark">{SCHEDULES.NOON}</span>
              <br />
              <input
                type="checkbox"
                checked={scheduleThree}
                onChange={() => setScheduleThree(!scheduleThree)}
              />
              <span class="checkmark">{SCHEDULES.AFTERNOON}</span>
            </StyledLabel> */}
            </AlignLeft>
            <Button
              style={{ fontSize: 15, fontWeight: 'bold', margin: 24, cursor: 'pointer' }}
              type="submit"
              form="form1"
              value="Submit"
            >
              <Title align="center" style={{ width: '100%' }} level={5} color="white" medium>
                Agendar diagnóstico
              </Title>
            </Button>
            <Text style={{ marginBottom: '10px', fontSize: '0.8em' }} type="body1" color="gray">
              Al hacer clic en "Agendar diagnóstico" estás aceptando nuestro
              <a href="https://www.finauta.com/aviso"> aviso de privacidad </a> y{' '}
              <a href="https://www.finauta.com/terminos">términos y condiciones.</a>
            </Text>
          </StyledForm>
        </StyledFormContainer>
      </StyledFormBackground>
    </>
  );
};

export default HubspotForm;
